import axios from "axios"
import { useState } from "react"
function App() {
    const [deg,setdeg] = useState("238")
    const [city,setcity] =useState("London")
    const [desc,setdesc] = useState("Raining")
    const [enteredvalue,setenteredvalue] = useState("")
    function handleInput(event)
    {
        console.log(event.target.value)
        setenteredvalue(event.target.value)
    }
    function getData(){


        var weather = axios(`https://api.openweathermap.org/data/2.5/weather?q=${enteredvalue}&appid=7c40e7dea1daa984ff195efd35cd8342`)


        weather.then(function(dalta){
                    setdeg(dalta.data.main.temp)
                    setdesc(dalta.data.weather[0].description)
                    setcity(dalta.data.name)
        })
    }
    return (<div className="flex flex-row justify-center h-[100vh] items-center">
        <div style={{backgroundImage:"linear-gradient(to top, #a8edea 0%, #fed6e3 100%)"}} className="p-2 rounded-md shadow">
            <h1 className="font-medium">Hey!⛅</h1>
            <p className="text-xs">Do you want to know the weather report :) </p>
            <input onChange={handleInput} type="text" className="rounded-md h-6 text-sm mt-2 p-1 outline-none" placeholder="Cityname?"/>
            <br/>
            <button onClick={getData} className="bg-black text-white rounded-lg p-2 text-xs mt-2">Get Report⚡</button>
            <p className="text-xs mt-2">Temperature: {deg} | City: {city}  | Weather: {desc}</p>
        </div>
    </div>
    )
}
export default App
